// config.js
const config = {
	// apiBaseUrl: "https://national-recycling.local/wp-json",
	apiBaseUrl: "https://nationalpaper-recycling.co.uk/wp-json",
};

export default config;
